import { render, staticRenderFns } from "./edit-topic.html?vue&type=template&id=75c0bff0&scoped=true&"
import script from "./edit-topic.js?vue&type=script&lang=js&"
export * from "./edit-topic.js?vue&type=script&lang=js&"
import style0 from "./edit-topic.css?vue&type=style&index=0&id=75c0bff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c0bff0",
  null
  
)

export default component.exports